import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { CategoryService } from '../../../services/category.service';
import { TareasService } from '../../../services/tareas.service';
import { NewTask, VerTask } from '../../../models/tarea/tarea.module';
import { GLOBAL_IMAGES, GLOBAL_DOCS } from '../../../services/global.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {
  @Input() info: any;
  @Output() cerrarInfo: EventEmitter<any>;

  task: NewTask;
  comentario: NewTask;
  agrega_info: VerTask;
  datos;
  token;
  url: string;
  url_doc: string;
  id_us: number;
  email: string;
  loading: boolean = false;
  public options: Object = {
    placeholderText: 'Escribe un comentario',
    charCounterCount: false
  }
  constructor(private _userService: UserService, private _categoryService: CategoryService , private _tareasService: TareasService) {
    this.cerrarInfo = new EventEmitter();
    const token = this._userService.getToken();
    this.token = token;
    this.url = GLOBAL_IMAGES.url;
    this.url_doc = GLOBAL_DOCS.url;
    let user = this._userService.getIdentity();
    this.id_us = user.sub;
    this.email = user.email;
    this.comentario = new NewTask(0,"",this.id_us,"","","","","",0,0,false,[],"");
  }

  ngOnInit(): void {
  }
  ngOnChanges(): void{
    //console.log(this.info);

    if(this.info.nombre == null || this.info.nombre == undefined){
      this.task = new NewTask(this.info.id, '', this.id_us, '', this.email, '', '', '', 0, 0, false, [], '');
      this.getData();
      this.getInfo();
    } else {
      this.task = new NewTask(this.info.id_tarea, this.info.nombre, this.info.tipo_fecha, this.info.hora, this.info.hora2, this.info.fecha, this.info.fecha2, this.info.comentarios, this.info.importancia, this.info.estatus, this.info.privada,[], this.info.color);
      this.getInfo();
    }

    //console.log(this.agrega_info);
    //console.log(this.datos);
  }

  getInfo(){
    //console.log(this.task);
    
    this._tareasService.taskView(this.task, this.token).subscribe(
      response => {
          //console.log(response);
          this.datos = response;
          //console.log(this.datos);
      },
      error => {
        console.log(error);
      }
    );
    //console.log(this.datos);
  }

  getData(){
    
    this._tareasService.taskData(this.task, this.token).subscribe(
      response => {
         //console.log(response);
        // console.log(response.tareas);
        // console.log(response.tareas[0]);
        // console.log(response.tareas[0].nombre);
        this.agrega_info = new VerTask(response.tareas[0].nombre, "", "", "", "", "", "", "", 0, 0, "", "", "",0, 0, 0);
         this.info.nombre = response.tareas[0].nombre;
         this.info.fecha = response.tareas[0].fecha;
          this.info.estatus = response.tareas[0].estatus;
          this.info.comentarios = response.tareas[0].comentarios;
          this.info.importancia = response.tareas[0].importancia;
          this.info.importancia_color = response.tareas[0].importancia_color;
          this.getInfo();
        //   this.datos.usuarios = response.tareas[0].users;
       
        //   this.datos.comentarios = response.comentarios;
        //   console.log(this.datos);
          
      },
      error => {
        console.log(error);
      }
    );

  }

  onSubmit(form){
    //console.log(form.value);
    this.comentario.comentario = form.value.comentario
    //console.log(this.comentario);
    this.comentario.id = this.info.id_tarea;
    //console.log(this.comentario);
    this._tareasService.AddComentario(this.comentario, this.token).subscribe(
      response => {
          this.getInfo();
          this.comentario.comentario = "";
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: response.message,
            showConfirmButton: false,
            timer: 1500
          });
      },
      error => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Ocurrio un error, actualiza la página',
          showConfirmButton: false,
          timer: 1500
        });
        console.log(error);
      }
    );
  }
  eliminar_comentario(id){
    Swal.fire({
      title: '¿Eliminar el documento?',
      text: "Desea eliminar el documento de la tarea",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {

        this.comentario.estatus = id;
        //console.log(this.comentario);
        this._tareasService.DelComentario(this.comentario, this.token).subscribe(
          response => {
              this.getInfo();
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: response.message,
                showConfirmButton: false,
                timer: 1500
              });
          },
          error => {
            console.log(error);
          }
        );

      }
    });


  }
  cerrar(){
    this.cerrarInfo.emit();
  }
}
